import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";
import Commission from "../../../classes/Commission";

export default {
  routes: [
    {
      name: "commission",
      path: "commission",
      meta: {
        auth: () => Commission.canBeViewedBy(store.state.main.user),
        icon: "commission",
        title: i18n.global.tc("Commission"),
        crumbs: ["accounting", "payroll"],
        color: "primary",
      },
      component: () => import("pages/admin/Commission"),
    },
    {
      name: "commission-paid",
      path: "commission/paid",
      meta: {
        auth: () => Commission.canBeViewedBy(store.state.main.user),
        icon: "commission",
        title: i18n.global.tc("Commission"),
        crumbs: ["accounting", "payroll"],
        color: "primary",
        hideFromIndex: true,
      },
      component: () => import("pages/admin/Commission"),
    },
    {
      name: "commission-search",
      path: "commission/search/:query?",
      meta: {
        auth: () => Commission.canBeViewedBy(store.state.main.user),
        icon: "commission",
        title: i18n.global.tc("Commission"),
        crumbs: ["accounting", "payroll"],
        color: "primary",
        hideFromIndex: true,
      },
      component: () => import("pages/admin/Commission"),
    },
  ],

  dialogs: [
    {
      name: "commission-view",
      path: "/users/:userID/commission/:commissionID/view",
      meta: {
        auth: () => Commission.canBeViewedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/employee/CommissionView"),
    },
  ],
};
